import { type SetStateAction, useEffect } from 'react'

import { PaginationBar } from '../../../../../../components/PaginationBar'
import { NoArchivedProjectsMessage } from './NoArchivedProjectsMessage'
import { ArchivededProjectsList } from './ArchivedProjectsList'
import { useFiledProjectsQuery } from '../../../../../../services/hooks/projects/queries/useProjectQuery'
import { type FiltersDomain } from '../../../../../../types/domain/filters-domain'
import { type ProjectDomain } from '../../../../../../types/domain/project-domain'

type ManualArchivedProjectPaginationContainerProps = {
  filters: FiltersDomain
  setFilters: React.Dispatch<SetStateAction<FiltersDomain>>
  onArquivedProjectItemClick: (archivedProject: ProjectDomain) => void
}

export const ManualArchivedProjectPaginationContainer = ({
  filters,
  setFilters,
  onArquivedProjectItemClick,
}: ManualArchivedProjectPaginationContainerProps) => {
  const { data } = useFiledProjectsQuery(filters)

  const handlePageChange = (newPage: number) => {
    setFilters((prevState) => ({
      ...prevState,
      page: newPage,
    }))
  }

  const handleChangeRegistersPerPage = (newRegistersPerPage: number) => {
    setFilters((prevState) => ({
      ...prevState,
      take: newRegistersPerPage,
    }))
  }

  useEffect(() => {
    setFilters((prevState) => ({ ...prevState, take: 10 }))
  }, [])

  const arquivedProjects = data?.data || []

  return (
    <>
      <div>
        <div className="mb-4">
          <div className="bg-secondary-dark rounded-[10px] px-6 py-3 mb-2">
            <p className="text-base font-semibold text-white ">Nome</p>
          </div>

          <NoArchivedProjectsMessage
            isVisible={arquivedProjects.length === 0}
          />

          <ArchivededProjectsList
            archivedProjects={arquivedProjects || []}
            onArquivedProjectItemClick={onArquivedProjectItemClick}
          />
        </div>

        {arquivedProjects.length > 0 && (
          <PaginationBar
            onChangingRegistersPerPage={handleChangeRegistersPerPage}
            currentPage={filters.page}
            onPageChange={handlePageChange}
            totalCountOfRegisters={data?.meta.itemCount || 0}
            siblingsCount={2}
            registersPerPage={filters.take}
          />
        )}
      </div>
    </>
  )
}
